export const format = {
  date: 'yyyy-MM-dd',
  defaultDate: 'YYYY-MM-DD'
};
